/** @file Inspector form kind of an entity (attachments split into region and mesh), and view props. */
import type { Doc, EntityKind, Id } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import type { ENTITY_FORMS } from './entityForms.data';

/** A key of ENTITY_FORMS. */
export type FormKind = keyof typeof ENTITY_FORMS;

/** What every Inspector entity view receives (`id` is '' for the project). */
export interface EntityViewProps {
  doc: Doc;
  kind: FormKind;
  id: Id;
  t: Translate;
}

/** `region` or `mesh` for an attachment, the entity kind for the other generated kinds, null for panels of other areas. */
export function formKindOf(doc: Doc, kind: EntityKind, id: Id): FormKind | null {
  if (kind === 'attachment') return doc.attachments[id]?.type === 'mesh' ? 'mesh' : 'region';
  return kind === 'bone' || kind === 'slot' || kind === 'image' ? kind : null;
}
